export let PackagePickerSteps = /*#__PURE__*/function (PackagePickerSteps) {
  PackagePickerSteps["SELECT_PLAN"] = "select-plan";
  PackagePickerSteps["SELECT_CYCLE"] = "select-cycle";
  PackagePickerSteps["CHECKOUT"] = "checkout";
  PackagePickerSteps["ANY"] = "*";
  return PackagePickerSteps;
}({});

// please don't change type - https://wix.atlassian.net/browse/PREM-13075

export let SiteAuthorization = /*#__PURE__*/function (SiteAuthorization) {
  SiteAuthorization["AUTHORIZED"] = "authorized";
  SiteAuthorization["UNAUTHORIZED"] = "unauthorized";
  return SiteAuthorization;
}({});

// TODO: Move elsewhere, it's api client related
//# sourceMappingURL=types.js.map